export default __webpack_public_path__ + "static/media/3_zvuk.9a00cc48.wav";